import React from 'react'

import Main from '../components/Main/Main'
import SideBar from '../components/Sidebar/Sidebar'

const Dashboard = () => {
    return (
        <div>
            <SideBar />
            <Main/>
        </div>
    )
}

export default Dashboard
